import {Injectable} from '@angular/core';
import {Constants} from '../constants/constants';
import {PermissionManagerService} from './permission-manager.service';
import {Controles} from '../constants/controles';
import {UtileriasService} from './utilerias.service';


@Injectable({
  providedIn: 'root'
})
export class TablaValidacionesService {
  Control = Controles;

  constructor(public constants: Constants,
              private utileriasService: UtileriasService,
              private permissionManagerService: PermissionManagerService) {
  }

  setStyleColumn(tabla: string, dataSource: any, column?: any): string {

    switch (tabla) {
      case this.constants.FICORFIN:
        if (dataSource.capturadoDeposito == false && dataSource.idcorest == 0 && column != 'fechaVencimiento') {
          return 'alert alert-warning';
        } else if (dataSource.capturadoDeposito == true && dataSource.idcorest == 0 && column != 'fechaVencimiento') {
          return 'alert alert-success';
        } else if (dataSource.idcorest != 0 && dataSource.cartaInstruccion == '' && column != 'fechaVencimiento') {
          return 'alert alert-danger';
        } else if (dataSource.idcorest == 2 && (dataSource.cartaInstruccion == '' || dataSource.solicitudCorrida == ''
          || dataSource.comprobante == '') && column != 'fechaVencimiento') {
          return 'alert alert-danger';
        } else if (dataSource.idcorest == 1 && dataSource.solicitudCorrida == '' && dataSource.inicial == false && column != 'fechaVencimiento') {
          return 'alert alert-danger';
        } else if (column == 'fechaVencimiento') {
          return this.utileriasService.getColor(dataSource.fechaVencimiento);
        } else {
          return 'alert alert-success';
        }
        break;
      case this.constants.FICORRET:
        if (dataSource.pagada == false && column == 'comision') {
          return 'alert alert-warning';
        }

        if (dataSource.numeroAdjuntos < 4 && column == 'numeroAdjuntos') {
          return 'alert alert-warning';
        }
        break;
    }

    return '';
  }

  setDisplayColumn(tabla: string, dataSource: any, column: any, isDocumentacion: boolean): boolean {

    switch (tabla) {
      case this.constants.PSACCION:
        if (dataSource.adjunto === '' && column === this.constants.PDF) {
          return false;
        } else {
          return true;
        }
        break;

      case this.constants.FICORFIN:
        if ((dataSource.idterest < 5 || dataSource.idterest == 8 || dataSource.idcorest != 0) && dataSource.inicial == true && column === this.constants.CONVENIOS) {
          return false;
        } else if (dataSource.idterest == 8 && column === this.constants.PAGADO && dataSource.inicial == true) {
          return false;
        } else if ((dataSource.idterest < 4 || dataSource.idterest == 8) && dataSource.capturadoDeposito == false
          && column === this.constants.MOVIMIENTOS) {
          return false;
        } else if (dataSource.inicial == false && (column === this.constants.CONVENIOS || column === this.constants.PAGADO)) {
          return false;
        } else if (dataSource.inicial == true && (dataSource.cartaInstruccion == '')
          && column === this.constants.MOVIMIENTOS) {
          return false;
        } else if (dataSource.inicial == false && ((dataSource.idcorest != 0 && dataSource.cartaInstruccion == '') || (dataSource.inicial == false && dataSource.solicitudCorrida == ''))
          && column === this.constants.MOVIMIENTOS) {
          return false;
        } else if ((column === this.constants.PDF || column === this.constants.PAGADO) && dataSource.idcorest != 0 && dataSource.inicial == true) {
          return false;
        } else if (column === this.constants.CARTA && dataSource.inicial == false && dataSource.idcorest == 0) {
          return false;
        } else if (column === this.constants.RENOVACION && dataSource.idcorest != 1) {
          return false;
        } else {
          return true;
        }
        break;

      case this.constants.FICORRET:
        if (dataSource.adjunto !== '' && column === this.constants.UPLOAD) {
          return false;
        } else if (dataSource.pagada == true && column === this.constants.EDITAR) {
          return false;
        } else if (dataSource.pagoAfin == false && column === this.constants.MOVIMIENTO_AFIN) {
          return false;
        } else if (dataSource.pagada == false && column === this.constants.PAGADO) {
          return false;
        } else {
          return true;
        }
        break;

      case this.constants.FIMOVINV:
        if (isDocumentacion == false && dataSource.idtipmov == 99 && (column === this.constants.EDITAR || column === this.constants.VISUALIZAR)) {
          return false;
        } else if (isDocumentacion == false && (dataSource.tipoMovimiento == 'Aportación Adherente' || dataSource.tipoMovimiento == 'Ingreso' || dataSource.tipoMovimiento.substring(0, 4) == 'Pago') && column === this.constants.DOCUMENTOS) {
          return false;
        } else {
          return true;
        }
        break;

      default:
        return true;
        break;
    }


  }

  isGranted(tabla: string, column: any, isDocumentacion: boolean): boolean {


    switch (tabla.trim()) {
      case this.constants.PSADJTER:
        switch (column) {
          case this.constants.ELIMINAR_DOCUMENTACION:
            return this.permissionManagerService.isGranted(this.Control.ELIMINAR_DOCUMENTOS_FIGURAS_ADHERENTES);
            break;
          default:
            return true;
            break;
        }
        break;

      case this.constants.FICORFIN:
        switch (column) {
          case this.constants.PAGADO:
            return this.permissionManagerService.isGranted(this.Control.PAGO_DEPOSITO_INVERSION);
            break;
          default:
            return true;
            break;
        }
        break;


      case this.constants.FICORRET:
        switch (column) {
          case this.constants.ELIMINAR_DOCUMENTACION:
            return this.permissionManagerService.isGranted(this.Control.ELIMINAR_DOCUMENTOS_RENDIMIENTOS);
            break;
          case this.constants.EDITAR:
            return this.permissionManagerService.isGranted(this.Control.EDITAR_MOVIMIENTO_INVERSION);
            break;
          default:
            return true;
            break;
        }
        break;

      case this.constants.FIMOVINV:
        switch (column) {
          case this.constants.ELIMINAR_DOCUMENTACION:
            return this.permissionManagerService.isGranted(this.Control.ELIMINAR_DOCUMENTOS_INVERSION);
            break;
          case this.constants.EDITAR:
            return this.permissionManagerService.isGranted(this.Control.EDITAR_MOVIMIENTO_EGRESO);
            break;
          default:
            return true;
            break;
        }
        break;
    }

    return true;
  }


  displayCurrency(tabla: string, dataSource: any, column: any): boolean {
    return true;
  }

}
